"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.managedPromptTypeFor = exports.SavedPromptsProvider = exports.PROMPT_TYPE_LABELS = exports.PROMPT_TYPES = void 0;
exports.useSavedPrompts = useSavedPrompts;
var _react = _interopRequireWildcard(require("react"));
var _webApi = require("../utils/web-api");
var _AuthContext = require("../context/AuthContext");
var _AnalyticsContext = require("./AnalyticsContext");
var _toast = require("../utils/toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PROMPT_TYPES = exports.PROMPT_TYPES = ['chat', 'system', 'skill'];
var PROMPT_TYPE_LABELS = exports.PROMPT_TYPE_LABELS = {
  chat: 'Prompt',
  system: 'System prompt',
  skill: 'Skill'
};
var managedPromptTypeFor = exports.managedPromptTypeFor = function managedPromptTypeFor(type) {
  if (type === 'skill') return 'skill';
  if (type === 'chat') return 'prompt';
  return null;
};
var SavedPromptsContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var SavedPromptsProvider = exports.SavedPromptsProvider = function SavedPromptsProvider(_ref) {
  var children = _ref.children;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    isLoggedIn = _useAuthInfo.isLoggedIn;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useState = (0, _react.useState)({
      chat: [],
      system: [],
      skill: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    promptsByType = _useState2[0],
    setPromptsByType = _useState2[1];
  var _useState3 = (0, _react.useState)({
      chat: false,
      system: false,
      skill: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingByType = _useState4[0],
    setLoadingByType = _useState4[1];
  var _useState5 = (0, _react.useState)({
      chat: null,
      system: null,
      skill: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    errorByType = _useState6[0],
    setErrorByType = _useState6[1];
  var loadPrompts = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
      var managedType, _yield$Promise$all, _yield$Promise$all2, userPrompts, managedPrompts, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (authHeader) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, true));
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, null));
            });
            _context.p = 2;
            managedType = managedPromptTypeFor(type);
            _context.n = 3;
            return Promise.all([(0, _webApi.getUserPrompts)(authHeader, type), managedType ? (0, _webApi.getManagedPrompts)(authHeader, managedType) : []]);
          case 3:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            userPrompts = _yield$Promise$all2[0];
            managedPrompts = _yield$Promise$all2[1];
            setPromptsByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, [].concat(_toConsumableArray(managedPrompts), _toConsumableArray(userPrompts))));
            });
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error("Failed to load prompts for type ".concat(type, ":"), _t);
            sendError(_t instanceof Error ? _t : new Error('Failed to load prompts'), {
              component: 'SavedPromptsContext',
              action: 'load_prompts',
              promptType: type
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, _t instanceof Error ? _t.message : 'Failed to load prompts'));
            });
            (0, _toast.toastError)("Failed to load ".concat(type, " prompts"));
          case 5:
            _context.p = 5;
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, false));
            });
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [authHeader, sendError]);
  var createPrompt = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(type, data) {
      var prompt, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (authHeader) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, null);
          case 1:
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, true));
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, null));
            });
            _context2.p = 2;
            _context2.n = 3;
            return (0, _webApi.createUserPrompt)(authHeader, _objectSpread(_objectSpread({}, data), {}, {
              type: type
            }));
          case 3:
            prompt = _context2.v;
            setPromptsByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, [prompt].concat(_toConsumableArray(prev[type].filter(function (p) {
                return p.id !== prompt.id;
              })))));
            });
            (0, _toast.toastSuccess)("".concat(PROMPT_TYPE_LABELS[type], " saved"));
            return _context2.a(2, prompt);
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            console.error("Failed to create prompt for type ".concat(type, ":"), _t2);
            sendError(_t2 instanceof Error ? _t2 : new Error('Failed to create prompt'), {
              component: 'SavedPromptsContext',
              action: 'create_prompt',
              promptType: type,
              promptName: data.name
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, _t2 instanceof Error ? _t2.message : 'Failed to create prompt'));
            });
            (0, _toast.toastError)("Failed to create ".concat(PROMPT_TYPE_LABELS[type].toLowerCase()));
            return _context2.a(2, null);
          case 5:
            _context2.p = 5;
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, false));
            });
            return _context2.f(5);
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 4, 5, 6]]);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }(), [authHeader, sendError]);
  var updatePrompt = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id, type, data) {
      var prompt, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (authHeader) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2, null);
          case 1:
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, true));
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, null));
            });
            _context3.p = 2;
            _context3.n = 3;
            return (0, _webApi.updateUserPrompt)(authHeader, id, _objectSpread(_objectSpread({}, data), {}, {
              type: type
            }));
          case 3:
            prompt = _context3.v;
            setPromptsByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, prev[type].map(function (p) {
                return p.id === id ? prompt : p;
              })));
            });
            (0, _toast.toastSuccess)("".concat(PROMPT_TYPE_LABELS[type], " saved"));
            return _context3.a(2, prompt);
          case 4:
            _context3.p = 4;
            _t3 = _context3.v;
            console.error("Failed to update prompt for type ".concat(type, ":"), _t3);
            sendError(_t3 instanceof Error ? _t3 : new Error('Failed to update prompt'), {
              component: 'SavedPromptsContext',
              action: 'update_prompt',
              promptType: type,
              promptId: id
            });
            setErrorByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, _t3 instanceof Error ? _t3.message : 'Failed to update prompt'));
            });
            (0, _toast.toastError)("Failed to update ".concat(PROMPT_TYPE_LABELS[type].toLowerCase()));
            return _context3.a(2, null);
          case 5:
            _context3.p = 5;
            setLoadingByType(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, type, false));
            });
            return _context3.f(5);
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 4, 5, 6]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }(), [authHeader, sendError]);
  var hasPreloadedRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (!isLoggedIn || hasPreloadedRef.current) return;
    hasPreloadedRef.current = true;
    PROMPT_TYPES.forEach(function (type) {
      loadPrompts(type);
    });
  }, [isLoggedIn]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SavedPromptsContext.Provider, {
    value: {
      promptsByType: promptsByType,
      loadingByType: loadingByType,
      errorByType: errorByType,
      loadPrompts: loadPrompts,
      createPrompt: createPrompt,
      updatePrompt: updatePrompt
    },
    "data-sentry-element": "SavedPromptsContext.Provider",
    "data-sentry-component": "SavedPromptsProvider",
    "data-sentry-source-file": "SavedPromptsContext.tsx",
    children: children
  });
};
function useSavedPrompts() {
  var ctx = (0, _react.useContext)(SavedPromptsContext);
  if (!ctx) throw new Error('useSavedPrompts must be used within a SavedPromptsProvider');
  return ctx;
}